/**
 * PayPal browser SDK client id (public).
 * Server-side verification uses PAYPAL_CLIENT_ID / PAYPAL_CLIENT_SECRET on the backend.
 */
export const PAYPAL_CLIENT_ID =
	import.meta.env.VITE_PAYPAL_CLIENT_ID ||
	'ARni4L2au2UrJiQ5MAhZ6x1DvU45y39H5absAGCtNNwdFdY412pOlCzWr8gB9ejNQym5LsiBC0WzTvP5'

/**
 * Shared PayPal JS SDK options for booking checkout / extend.
 * `applepay` must be listed next to `buttons`, otherwise the SDK loads only one of them.
 */
export const PAYPAL_SCRIPT_OPTIONS = {
	clientId: PAYPAL_CLIENT_ID,
	currency: 'EUR',
	components: 'buttons,applepay',
	disableFunding: 'credit,paylater,card,giropay,sepa',
} as const

export const PAYPAL_BUTTON_STYLE = {
	layout: 'vertical' as const,
	color: 'white' as const,
	disableMaxWidth: true,
	borderRadius: 12,
}
